import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputChecbox from "../../helpers/InputCheckbox";
import InputCombo from "../../helpers/InputCombo";

import InputInteger from "../../helpers/InputInteger";
import InputDate from "../../helpers/InputDate";
import InputEmail from "../../helpers/InputEmail";




function ClientFakForm(props)
{

 

    const [errTab, setErrTab] = useState([]); 
    const [row, setRow] = useState({       
        id: -1,

        aktualnie_wstrzymano_fakturowanie: '0',                
        typ_blokady: '0',     
        wstrzymane_fakturowanie: '0',

        blokada_uslug: '0',
        wykluczony: '0',  

        autoblokowanie_od: '',
        powiadom_adm_o_wstrzymaniu: '0',
        powiadom_adm_mail: '',
        powod_wstrzymania:'',

    });
    var tmpRow = row;


 


 



    const valChangeListener = (filedName, val, correct, msg) => {   
        
              
        
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         


               

                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                        
            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_home,client_fak_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                props.onSuccess(res.result);  //przekaz id Firmy 
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



    const getFak = () => {
        
        props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_home,client_fak', {
            method: 'POST', 
            body: JSON.stringify({id: props.id}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

               props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }

 


      useEffect(() => {
        
                
                if(row.id == -1) getFak();


                if(Config.env == "dev") console.log("ClientFakForm.js, listener on");
                window.onkeydown = function (e) 
                {
                        var code = e.keyCode ? e.keyCode : e.which;    
                        console.log("keylockd", e.target.nodeName, code );

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else 
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                                           
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else 
                        {
                            props.mainView.keyListener(e);
                        }
                        
                                                             
                }

                return () => {          
                    if(Config.env == "dev") console.log("ClientFakForm.js, listener off");      
                    window.onkeydown = null;
                };

      });
   

    
 

    
    document.title = "Blokady i fakturowanie";

    return <div className="view_content">

                  
 
          
                       <form className="eForm bg_center">
                           

                                <div className="form_tab_title">Informacje o fakturowaniu</div>
                           
                                <div className="form_tab"> 
                                    
                                            <div className="form_control">
                                                <div className="fieldName">Fakturowanie aktualnie wstrzymane?*</div>
                                                <InputCombo   items={[  {v:'0',title:'Nie'},  {v:'1',title:'Tak'},  ]} value={row.aktualnie_wstrzymano_fakturowanie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="aktualnie_wstrzymano_fakturowanie" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>
 
                                            <div className="form_control">
                                                <div className="fieldName">Kiedy wznowić?*</div>
                                                <InputCombo   items={[  {v:'0',title:'Po zapłaceniu'},  {v:'2',title:'Warunkowe wznowienie'},  ]} value={row.typ_blokady} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_blokady" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>

                                            <div  className="form_split" />

                                             <div className="form_control">
                                                <div className="fieldName">Autowstrzymywanie fakturowania?*</div>
                                                <InputCombo   items={[  {v:'0',title:'Nie'},  {v:'1',title:'Tak'},  ]} value={row.wstrzymane_fakturowanie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wstrzymane_fakturowanie" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>

                                </div>



                                <div className="form_tab_title">Informacje o usłudzę</div>
                           
                                <div className="form_tab"> 
                                    
                                            <div className="form_control">
                                                <div className="fieldName">Aktualny stan usług*</div>
                                                <InputCombo   items={[  {v:'0',title:'Brak blokady'},  {v:'1',title:'Blokada usług'},  ]} value={row.blokada_uslug} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="blokada_uslug" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>
 
                                            <div className="form_control">
                                                <div className="fieldName">Autoblokady*</div>
                                                <InputCombo   items={[  {v:'0',title:'Blokuj klienta, gdy nie zapłaci oraz wysyłaj powiadomienia'},  {v:'1',title:'Nigdy nie blokuj tego klienta - brak powiadomien'},   {v:'2',title:'Nigdy nie blokuj tego klienta - powiadomienia'},  ]} value={row.wykluczony} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wykluczony" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>

                                </div>


                                <div className="form_tab_title">Opcje dodatkowe</div>

                                <div className="form_tab"> 

                                            <div className="form_control">
                                                <div className="fieldName">Autowstrzymywanie od (wydłużony termin zapłaty)</div>
                                                <InputDate     value={row.autoblokowanie_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="autoblokowanie_od" placeholder={""} className='  ' req='0' firstUp="1" />
                                            </div>

                                            <div className="form_split"/>

                                            <div className="form_control">
                                                <div className="fieldName">Powiadom o wstrzymaniu*</div>
                                                <InputCombo   items={[  {v:'0',title:'Nie'},  {v:'1',title:'Tak'},  ]} value={row.powiadom_adm_o_wstrzymaniu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="powiadom_adm_o_wstrzymaniu" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>

                                            {
                                                row.powiadom_adm_o_wstrzymaniu == 1 && 
                                                <div className="form_control">
                                                    <div className="fieldName">Wyślij info na e-mail:</div>
                                                    <InputEmail   value={row.powiadom_adm_mail} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="powiadom_adm_mail" placeholder={""} className='  ' req='1' firstUp="1" />
                                                </div>
                                            }

                                            

                                </div>
 
  

                                <div className="form_split"></div>

                                <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany</div>
                                       
                                </div>

                       </form>
    </div>
}


export default ClientFakForm;